export default __webpack_public_path__ + "static/media/navigation.e94e1a99.png";